module.exports = __webpack_public_path__ + "static/media/owl flying.473f6510.gif";